// 按需引入vant组件
import Vue from "vue";
import {
    Checkbox,
    CheckboxGroup,
    SwipeCell,
    Dialog,
    Button,
    Icon,
    Tabbar,
    TabbarItem,
    Swipe,
    SwipeItem,
    Lazyload,
    Grid,
    GridItem,
    Image as VanImage,
    Search,
    Sidebar,
    SidebarItem,
    Popup,
    Stepper,
    Toast,
    AddressEdit,
    Area,
    Badge,
    Cell,
    CellGroup,
    Uploader,
    List,
    Tab,
    Tabs,
    PullRefresh,
    Picker, Field,RadioGroup, Radio,Cascader
} from "vant";

Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(SwipeCell);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(VanImage);
Vue.use(Search);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Popup);
Vue.use(Stepper);
Vue.use(Toast);
Vue.use(AddressEdit);
Vue.use(Area);
Vue.use(Badge);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Uploader);
Vue.use(List);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(PullRefresh);
Vue.use(Picker);
Vue.use(Field);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Cascader)